import api from './api';

export const admissionsAPI = {
  getAdmissionsByParams: (params = {}) => api.get(`/admissions/get-admissions-by-params`, { params }),
  createAdmission: (admissionData) => api.post(`/admissions/add-admission`, admissionData),
  processAdmission: (admissionData) => api.post(`/admissions/process-admission`, admissionData),
  confirmAdmission: (admissionId, admissionData) => api.post(`/admissions/confirm-admission/${admissionId}`, admissionData),
  deleteAdmission: (admissionId) => api.delete(`/admissions/delete-admission/${admissionId}`),
  getAdmissions: () => api.get(`/admissions/get-admissions`),
  updateAdmission: (admissionId, admissionData) => api.post(`/admissions/update-admission/${admissionId}`, admissionData),
};

//add
//update
//delete